<template>
    <v-container>
      <v-row class="elevation-1">
        <v-col cols="6" lg="12">
          <v-btn
            id="create-new-fiscal-year"
            class="mx-2" color="primary"
            @click="openDialogbox"
          >
            Create New Fiscal Year
          </v-btn>
          <GlCreateFiscalYear
          :dialog="dialog"
          @dialogVal="setDialog"
          />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import GlCreateFiscalYear from '../../../components/Gl/CreateFiscalYear/GlCreateFiscalYear.vue';

export default {
  name: 'GeneralLedgerCreateFiscalYear',
  components: {
    GlCreateFiscalYear,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {

  },
  methods: {
    openDialogbox() {
      this.dialog = true;
    },
    setDialog(val) {
      this.dialog = val;
    },
  },
};
</script>
